import React from 'react';
import { JiraLightTheme } from '../../assets/jira/light-theme';
import { DesktopOnlyBackground } from '../../common/ui';
export var JiraBackground = function JiraBackground(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(DesktopOnlyBackground, {
    background: JiraLightTheme
  }, children);
};